import CONSTANTS from '../constants';
import ItemService from '../services/ItemService';
import ItemHelper from '../helpers/ItemHelper';

export function getAllItems(location, history = {}) {
  return async (dispatch) => {
    try {
      //let items = await ItemService.getItems(location.menu_blob, location.loc_id);
      let categories = await ItemService.getCategoryItem(location.menu_blob, location.loc_id);
      let items = [];
      categories.forEach((category) => {
        let data = category.menu;
        data.forEach((item) => {
          item.loc_id = location.loc_id;
          item.category_name = category.name;
          if (item.menu_photo.includes('dishPlaceholderImg')) item.menu_photo = null;
          items.push(item);
        });
      });
      dispatch({ type: CONSTANTS.ACTIONS.ITEMS.LIST_CAT, cat_items: categories });
      dispatch({ type: CONSTANTS.ACTIONS.ITEMS.LIST, items: items });

      let popularItems = await ItemService.getPopularItems(location.slug);
      let popularItemsArray = [];
      popularItems.forEach((popularItem) => {
        let item = items.find((item) => item.menu_id === popularItem.id);
        if (item) popularItemsArray.push(item);
      });
      dispatch({ type: CONSTANTS.ACTIONS.ITEMS.POPULAR_LIST, popularItems: popularItemsArray });
    } catch (error) {
      console.log('Error: ', error);
    }
  };
}

export function getItem(itemId, items) {
  return async (dispatch) => {
    try {
      // dispatch null item so that previous item gets cleared and splash screen gets displayed
      dispatch({ type: CONSTANTS.ACTIONS.ITEMS.GET, item: null });
      let item = ItemHelper.findItemInArray(itemId, items);
      dispatch({ type: CONSTANTS.ACTIONS.ITEMS.GET, item: item });
    } catch (error) {
      console.log('Error: ', error);
    }
  };
}

export function getItemDetails(itemId, history = {}) {
  return async (dispatch) => {
    try {
      // dispatch null item so that previous item gets cleared and splash screen gets displayed
      dispatch({ type: CONSTANTS.ACTIONS.ITEMS.GET_DETAILS, itemDetails: null });
      let item = await ItemService.getItem(itemId);
      dispatch({ type: CONSTANTS.ACTIONS.ITEMS.GET_DETAILS, itemDetails: item });
    } catch (error) {
      console.log('Error: ', error);
    }
  };
}
